import { type CustomPageViewEvent, customPageViewEventSchema } from './pageViewTrackingEventSchema';
import logger from '../logger';

export type CustomPageViewEventProps = Omit<CustomPageViewEvent, 'event'>;

export const buildCustomPageViewEvent = (
  props: CustomPageViewEventProps
): CustomPageViewEvent | null => {
  const event: CustomPageViewEvent = { event: 'custom_page_view', ...props };

  const result = customPageViewEventSchema.safeParse(event);

  let builtEvent: CustomPageViewEvent | null = null;
  if (result.success) {
    builtEvent = result.data;
  } else {
    logger.error(result.error, 'Invalid custom page view event');
  }

  return builtEvent;
};

export default buildCustomPageViewEvent;
